import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Setting";

export const SETTING_PREFIX_URL = PREFIX_URL;

export const CurrentVersion = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CurrentVersion`, options);

export const SaleDebtCreationMode = (options) =>
  GENERATE_URL(`${PREFIX_URL}/SaleDebtCreationMode`, options);

export const LeadTransferType = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LeadTransferType`, options);

export default {
  CurrentVersion,
  SaleDebtCreationMode,
  LeadTransferType,
};
